/*!
 * Prisma v2
 */

// Dependencies
import 'popper.js';
import 'bootstrap';
import 'slick-carousel';

// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function(e) {
  e.stopPropagation();
});

// Toggle tab
$(document).on('click', '.dropdown-menu .nav-link.active', function(e) {
  $(this).removeClass('active').attr('aria-selected', 'false');
  $(e.target.hash).removeClass('active show');
});

// Back button on mobile
$(document).on('click', '.tab-pane a.d-lg-none', function(e) {
  e.preventDefault();

  var tabId = $(this).closest('.tab-pane').attr('aria-labelledby');
  $(this).closest('.tab-pane').removeClass('active show');
  $('#'+tabId).removeClass('active').attr('aria-selected', 'false');
});

// Clear tabs on dropdown links
$('.dropdown-toggle').on('click', function() {
  $('.navbar-mega').find('.dropdown-menu .dropdown-item.active').removeClass('active').attr('aria-selected', 'false');
  $('.navbar-mega').find('.dropdown-menu .tab-pane.active').removeClass('active show');
});

// Slider range
$('.range-fill').on('input', function() {
  var value = (this.value - this.min) / (this.max - this.min) * 100;
  this.style.background = 'linear-gradient(to right, #009bdf 0%, #009bdf ' + value + '%, #e6e6e6 ' + value + '%, #e6e6e6 100%)';
});

// Offcanvas
$('[data-toggle="offcanvas"]').on('click', function() {
  var element = $(this).attr('data-target');
  offcanvas(element);
});

$(document).on('click', '.offcanvas-backdrop', function() {
  var element = '#' + $(this).prev().attr('id');
  offcanvas(element);
});

function offcanvas(id) {
  $(id).toggleClass('show');
  if ($(id).css('visibility') == 'visible' ) {
    $('.offcanvas-backdrop').toggleClass('show');
    setTimeout(function() {
      $(id).css({ visibility: 'hidden' });
      $(id).next().remove();
    }, 300);
  } else {
    $(id).css({ visibility: 'visible' });
    $(id).after('<div class="offcanvas-backdrop fade"></div>');
    setTimeout(function() {
      $('.offcanvas-backdrop').toggleClass('show');
    }, 100);
  }
};
